import { useEffect, useState } from "react";
import { CurrencyDollar } from "@phosphor-icons/react";

export const STAGES = [
  { id: "new", label: "New" },
  { id: "contacted", label: "Contacted" },
  { id: "proposal", label: "Proposal sent" },
  { id: "client", label: "Client" },
  { id: "lost", label: "Not a fit" },
];

export const STAGE_BADGE = {
  contacted: "bg-brand-forest/10 text-brand-forest",
  proposal: "bg-brand-copper/15 text-brand-copper",
  client: "bg-brand-copper text-white",
  lost: "bg-brand-muted/20 text-brand-muted",
};

export const LeadStageControls = ({ lead, onStage, onPremium, busy }) => {
  const status = lead.status || "new";
  const [premium, setPremium] = useState(lead.annual_premium || "");

  useEffect(() => { setPremium(lead.annual_premium || ""); }, [lead.annual_premium]);

  return (
    <div className="mt-5 pt-4 border-t border-brand-line">
      <div className="text-[10px] uppercase tracking-[0.16em] text-brand-muted mb-2">Pipeline stage</div>
      <div className="flex flex-wrap gap-1.5">
        {STAGES.map((s) => {
          const active = s.id === status;
          return (
            <button
              key={s.id}
              type="button"
              disabled={busy}
              onClick={() => !active && onStage(lead.id, s.id)}
              data-testid={`btn-stage-${s.id}-${lead.id}`}
              className={`px-3 py-1.5 rounded-full text-xs font-semibold transition-all disabled:opacity-50 disabled:pointer-events-none ${
                active
                  ? "bg-brand-forest text-white shadow-sm"
                  : "border border-brand-line text-brand-muted hover:text-brand-ink hover:border-brand-muted"
              }`}
            >
              {s.label}
            </button>
          );
        })}
      </div>

      {status === "client" && (
        <div className="mt-4 flex items-end gap-2" data-testid={`premium-row-${lead.id}`}>
          <div className="flex-1">
            <label
              htmlFor={`premium-${lead.id}`}
              className="block text-[10px] uppercase tracking-[0.16em] text-brand-muted mb-1.5"
            >
              Annual policy premium
            </label>
            <div className="relative">
              <CurrencyDollar
                size={15}
                weight="bold"
                className="absolute left-3 top-1/2 -translate-y-1/2 text-brand-muted"
              />
              <input
                id={`premium-${lead.id}`}
                data-testid={`input-premium-${lead.id}`}
                type="number"
                min="0"
                step="100"
                value={premium}
                onChange={(e) => setPremium(e.target.value)}
                placeholder="24,000"
                className="w-full h-10 pl-8 pr-3 rounded-md border border-brand-line bg-white text-sm tabular-nums focus:outline-none focus:ring-2 focus:ring-brand-forest"
              />
            </div>
          </div>
          <button
            type="button"
            disabled={busy}
            onClick={() => onPremium(lead.id, Number(premium) || 0)}
            data-testid={`btn-save-premium-${lead.id}`}
            className="h-10 px-4 rounded-md bg-brand-forest text-white text-xs font-semibold hover:bg-brand-copper transition-colors disabled:opacity-50"
          >
            Save
          </button>
        </div>
      )}
    </div>
  );
};
